import { GET_ADMIN_FAILURE, GET_ADMIN_REQUEST, GET_ADMIN_SECCESS, GET_BATCH_FAILURE, GET_BATCH_REQUEST, GET_BATCH_SUCCESS, GET_CATEGORY_FAILURE, GET_CATEGORY_REQUEST, GET_CATEGORY_SUCCESS, GET_SECTION_FAILURE, GET_SECTION_REQUEST, GET_SECTION_SUCCESS, GET_TAG_FAILURE, GET_TAG_REQUEST, GET_TAG_SUCCESS, GET_TYPE_FAILURE, GET_TYPE_REQUEST, GET_TYPE_SUCCESS } from "./actionTypes"

const initialState = {
    isLoading: false,
    isError: false,
    section: [],
    batch: [],
    type: [],
    tag: [],
    category: [],
    admin: []
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BATCH_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case GET_BATCH_SUCCESS:
            return {
                ...state,
                isLoading: false,
                batch: action.payload,
                isError: false
            }
        case GET_BATCH_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case GET_SECTION_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case GET_SECTION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                section: action.payload,
                isError: false
            }
        case GET_SECTION_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case GET_TYPE_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case GET_TYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                type: action.payload
            }
        case GET_TYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case GET_TAG_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case GET_TAG_SUCCESS:
            return {
                ...state,
                isLoading: false,
                tag: action.payload,
                isError: false
            }
        case GET_TAG_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case GET_CATEGORY_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case GET_CATEGORY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                category: action.payload
            }
        case GET_CATEGORY_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case GET_ADMIN_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case GET_ADMIN_SECCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                admin: action.payload
            }
        case GET_ADMIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        default:
            return {
                ...state
            }
    }
}